<script>
export default {
    name: 'FlagPortugal'
}
</script>
<template>
    <svg
        class="base-flag flag-portugal"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs><path id="a" d="M0 0h28v20H0z" /></defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <use fill="#FFF" xlink:href="#a" />
            <path fill="#FF2936" d="M0 0h28v20H0z" mask="url(#b)" />
            <path fill="#128415" d="M0 0h10.667v20H0z" mask="url(#b)" />
            <circle
                cx="10.667"
                cy="10"
                r="3.333"
                stroke="#FAF94F"
                stroke-width="1.333"
                mask="url(#b)"
            />
            <path
                fill="#FFF"
                d="M9.333 8.341c0-.188.144-.341.327-.341h2.013c.18 0 .327.152.327.341v2.327A1.33 1.33 0 0110.667 12c-.737 0-1.334-.59-1.334-1.332V8.341z"
                mask="url(#b)"
            />
            <path
                fill="#1D50B5"
                d="M10.667 10.667c.368 0 .666-.965.666-1.334a.666.666 0 10-1.333 0c0 .369.298 1.334.667 1.334z"
                mask="url(#b)"
            />
        </g>
    </svg>
</template>
